<template>
  <router-view />
</template>

<script>
export default {
  name: 'PawnInterestRate'
}
</script>

<style scoped>

</style>
